<template>
  <div class="chat-widget d-flex" style="flex-wrap: wrap; max-width: 16.5rem">
    <div v-for="(button, i) in message.buttons" :key="i">
      <button v-ripple v-if="i < item_showed" class="chat-btn quick-reply-button hover-btn text-none" :style="`color: ${config.main_color}`" outlined @click="click(button)">
        {{ button.title }}
      </button>
      <v-btn v-else-if="i === item_showed" class="chat-btn quick-reply-button" :style="`color: ${config.main_color}`" outlined @click="addItem"> ... </v-btn>
    </div>
  </div>
</template>

<script setup>
import global_config from '@/../config.json'
import { ref, defineProps, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'

// Init Modules
const store = useStore()

// Props
const { message, chat_i, message_i } = defineProps({
  message: Object,
  chat_i: Number,
  message_i: Number
})

// Data
const config = ref(global_config)
const item_showed = ref(null)
const item_to_add = ref(null)

// Methods
const click = ({ type, title, value }) => {
  if (type === 'web_url') window.open(value, '_blank')
  else store.dispatch('sendMessageToSocket', { title, value })

  store.commit('REMOVE_CHAT_HISTORY', { chat_i: chat_i, message_i: message_i })
}

const addItem = () => {
  var container_element = document.getElementById('chat_container')
  var chat_element = document.getElementById(`chat_${chat_i}`)
  var message_element = document.getElementById(`message_${chat_i}_${message_i}`)
  const old_scroll_height = message_element.scrollHeight

  item_showed.value += item_to_add.value
  nextTick(() => {
    const new_scroll_height = message_element.scrollHeight
    const scroll_amount = new_scroll_height - old_scroll_height
    const available_space = container_element.clientHeight - (chat_element.offsetTop + message_element.offsetTop + old_scroll_height - container_element.scrollTop) + 100

    if (available_space < scroll_amount) container_element.scrollTop = container_element.scrollTop + scroll_amount
  })
}
// Mounted
onMounted(() => {
  const { default_num_of_elements = null, default_num_of_elements_to_add = null } = message
  item_showed.value = default_num_of_elements ? default_num_of_elements : 3
  item_to_add.value = default_num_of_elements_to_add ? default_num_of_elements_to_add : 3
})
</script>

<style scope>
.quick-reply-button {
  margin: 0 0.5rem 0.5rem 0;
}
</style>
